import React from "react";

interface CellErrorBoundaryProps {
  children: React.ReactNode;
  resetKey?: string;
}

interface CellErrorBoundaryState {
  hasError: boolean;
  prevResetKey?: string;
}

export class CellErrorBoundary extends React.Component<
  CellErrorBoundaryProps,
  CellErrorBoundaryState
> {
  constructor(props: CellErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, prevResetKey: props.resetKey };
  }

  static getDerivedStateFromError(): Partial<CellErrorBoundaryState> {
    return { hasError: true };
  }

  static getDerivedStateFromProps(
    props: CellErrorBoundaryProps,
    state: CellErrorBoundaryState,
  ): Partial<CellErrorBoundaryState> | null {
    if (props.resetKey !== state.prevResetKey) {
      return { hasError: false, prevResetKey: props.resetKey };
    }
    return null;
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[CellErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <span className="text-red-400 text-xs px-1" title="Cell render error">
          --
        </span>
      );
    }
    return this.props.children;
  }
}
